import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: {
      userId: '',
      userName: '',
      firstName: '',
      lastName: '',
      dob: '',
      userStatus: null,
      phone: '',
      email: '',
      authorities: [],
      clubs: [],
      address: '',
      isUserAdmin: false,
      countryCode: '',
      profileImage: '',
      isFirstSubscription: false,
      featureWithPrivilege: {}
    },
    clubId: '',
    selectedClub: {}
  },

  reducers: {
    userInfo: (state, action) => {
      state.userInfo.userId = action.payload.userId
      state.userInfo.userName = action.payload.userName
      state.userInfo.firstName = action.payload.firstName
      state.userInfo.lastName = action.payload.lastName
      state.userInfo.userStatus = action.payload.userStatus
      state.userInfo.phone = action.payload.phone
      state.userInfo.email = action.payload.email
      state.userInfo.authorities = action.payload.authorities
      state.userInfo.clubs = action.payload.clubs
      state.userInfo.address = action.payload.address
      state.userInfo.dob = action.payload.dob
      state.userInfo.isUserAdmin = action.payload.isUserAdmin
      state.userInfo.countryCode = action.payload.countryCode
      state.userInfo.profileImage = action.payload.profileImage
      state.userInfo.isFirstSubscription = action.payload.isFirstSubscription
      state.selectedClub = action.payload.clubs[0]
    },
    resetUser: (state) => {
      state.userInfo.userId = ''
      state.userInfo.userName = ''
      state.userInfo.firstName = ''
      state.userInfo.lastName = ''
      state.userInfo.userStatus = null
      state.userInfo.phone = ''
      state.userInfo.email = ''
      state.userInfo.connectedAccountId = ''
      state.userInfo.authorities = []
      state.userInfo.clubs = []
      state.userInfo.address = ''
      state.userInfo.dob = ''
      state.userInfo.isUserAdmin = ''
    },
    setClubId: (state, action) => {
      state.clubId = action.payload;
    },
    setSelectedClub: (state, action) => {
      state.selectedClub = action.payload;
    },

  },
});

export const { userInfo, resetUser, setClubId, setSelectedClub, updateAccountSetup } = userSlice.actions;
export default userSlice.reducer;